import React from "react";
import classnames from "classnames";

export interface IContentContainer {
  leftColumns: number;
  rightColumns: number;
  leftContent: React.ReactNode;
  rightContent: React.ReactNode;
  isScreenHeight?: boolean;
  fixedHeight?: number;
  hiddenOnMobile?: "left" | "right";
  leftContainerClassName?: string;
  rightContainerClassName?: string;
}

function ContentContainer({
  leftColumns,
  rightColumns,
  leftContent,
  rightContent,
  leftContainerClassName,
  rightContainerClassName,
  fixedHeight,
  isScreenHeight,
  hiddenOnMobile,
}: IContentContainer) {
  return (
    <div
      className={classnames("grid grid-cols-1 md:auto-rows-fr", {
        [`md:grid-cols-${leftColumns + rightColumns}`]: true,
      })}
    >
      <div
        className={classnames("items-center flex", {
          [`md:col-span-${leftColumns}`]: Boolean(leftColumns),
          [`min-h-screen`]: Boolean(isScreenHeight),
          [`hidden md:block`]: hiddenOnMobile === "left",
          [leftContainerClassName || ""]: Boolean(leftContainerClassName),
        })}
        style={{ height: `${fixedHeight ? fixedHeight + "px" : "auto"}` }}
      >
        {leftContent}
      </div>
      <div
        className={classnames("relative h-full", {
          [`md:col-span-${rightColumns}`]: Boolean(rightColumns),
          [`hidden md:block`]: hiddenOnMobile === "right",
          [rightContainerClassName || ""]: Boolean(rightContainerClassName),
        })}
      >
        {rightContent}
      </div>
    </div>
  );
}

export { ContentContainer };
